export default class ViewerDialog {
    constructor(dialogId, showOverlay, overlayClickToClose, closeButtonId) {
        this._dialog = document.getElementById(dialogId);
        this._button = document.querySelector('*[aria-controls=' + dialogId + ']');

        if (showOverlay === true || showOverlay === null || showOverlay === undefined) {
            this._overlay = document.createElement('div');
            this._overlay.classList.add('dialog-overlay');
            this._overlay.setAttribute('aria-hidden', 'true');
            document.body.insertBefore(this._overlay, this._dialog.parent);

            if (overlayClickToClose === true || overlayClickToClose === null || overlayClickToClose === undefined) {
                this._overlay.addEventListener('click', this.close.bind(this), false);
            }
        }

        const buttonId = closeButtonId || null;
        if (buttonId !== null) {
            const closeButton = document.getElementById(buttonId);
            closeButton.addEventListener('click', this.close.bind(this), false);
        }
    }

    /**
     * ダイアログを表示します。
     */
    open() {

        if (this._dialog.getAttribute('aria-hidden') === 'false') return;

        this._dialog.setAttribute('aria-hidden', 'false');

        if (this._overlay !== null && this._overlay !== undefined) {
            this._overlay.setAttribute('aria-hidden', 'false');
        }

        if (this._button !== null && this._button !== undefined) {
            this._button.setAttribute('aria-expanded', 'true');
        }
    }

    /**
     * ダイアログを閉じます。
     */
    close() {

        if (this._dialog.getAttribute('aria-hidden') === 'true') return;

        this._dialog.setAttribute('aria-hidden', 'true');

        if (this._overlay !== null && this._overlay !== undefined) {
            this._overlay.setAttribute('aria-hidden', 'true');
        }

        if (this._button !== null && this._button !== undefined) {
            this._button.setAttribute('aria-expanded', 'false');
        }
    }

    /**
     * ダイアログの表示を切り替えます。 
     */
    toggle() {

        if (this._dialog.getAttribute('aria-hidden') === 'false') {
            this.close();
        }
        else {
            this.open();
        }
    }
}